import React from 'react';

import styles from './intercom.module.scss';

const Intercom: React.FC = () => {
  return <></>;
};

export default Intercom;
